import React from 'react';

const ArrowDown = ({ className }) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.9342 6.20291C10.8435 6.07757 10.6731 6.00002 10.4884 6H5.51147C5.32689 6.00007 5.15666 6.07757 5.06599 6.20282C4.97532 6.32807 4.97827 6.48165 5.0737 6.60473L7.56218 9.80778C7.65489 9.9271 7.82091 10 7.99996 10C8.179 10 8.34502 9.9271 8.43773 9.80778L10.9262 6.60473C11.0217 6.4817 11.0247 6.32816 10.9342 6.20291Z"
        fill="#54708C"
      />
    </svg>
  );
};
export default ArrowDown;
